export default "__VITE_PUBLIC_ASSET__d3c40b56__"